import React from "react";
import clsx from "clsx";

export function cn(...args) {
  return clsx(...args);
}

/** A simple button with brand styling. */
export const Button = React.forwardRef(function Button(
  { className, variant = "primary", size = "md", asChild = false, children, ...props },
  ref
) {
  const base =
    "inline-flex items-center justify-center gap-2 font-heading uppercase tracking-widest transition-all duration-200 border-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-orange focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none";
  const variants = {
    primary:
      "bg-brand-green text-white border-brand-green hover:bg-brand-orange hover:border-brand-orange",
    secondary:
      "bg-brand-orange text-white border-brand-orange hover:bg-brand-green hover:border-brand-green",
    outline:
      "bg-transparent text-brand-ink border-brand-ink hover:bg-brand-green hover:text-white hover:border-brand-green",
    ghost:
      "bg-white text-brand-green border-transparent hover:border-brand-green",
    darkOutline:
      "bg-transparent text-white border-white hover:bg-white hover:text-brand-green",
  };
  const sizes = {
    sm: "text-xs px-4 py-2",
    md: "text-xs md:text-sm px-6 py-3",
    lg: "text-sm md:text-base px-8 py-4",
  };
  return (
    <button ref={ref} className={cn(base, variants[variant], sizes[size], className)} {...props}>
      {children}
    </button>
  );
});
